import React, { useEffect } from "react";
import {
  Create,
  SimpleForm,
  BooleanInput,
  TextInput,
  maxLength,
  required,
  FormDataConsumer,
  useInput,
  useNotify,
  useRedirect,
  regex,
  ImageInput,
  ImageField,
} from "react-admin";

import { CachedCategoriesInput } from "../common/CachedCategoriesInput/CachedCategoriesInput";

// Componente intermedio para manejar la lógica del campo de categoría padre
const ConditionalParentCategoryInput = ({ formData, ...rest }) => {
  const { field } = useInput({ source: "parentIdField" });

  useEffect(() => {
    if (formData.isRootCategory && formData.parentIdField) {
      // Si es categoría raíz y parentIdField tiene un valor, lo reseteamos.
      field.onChange(undefined);
    }
  }, [formData.isRootCategory, formData.parentIdField, field]);

  return (
    <CachedCategoriesInput
      source="parentIdField"
      label="Categoría Padre"
      disabled={formData.isRootCategory}
      filter={{ parent: null }}
      validate={formData.isRootCategory ? [] : [required()]}
      allowEmpty={true} // Siempre permitir vacío, la validación se encarga del resto
      helperText={
        formData.isRootCategory
          ? "Es una categoría raíz, no necesita padre."
          : "Seleccione una categoría padre (solo se muestran categorías raíz)."
      }
      {...rest}
    />
  );
};

export const CategoryCreate = (props) => {
  const notify = useNotify();
  const redirect = useRedirect();

  const onSuccess = (data) => {
    notify("Se ha creado la categoría correctamente", {
      type: "info",
      undoable: false,
    });
    redirect("list", "/categories", data.id, data);
  };

  return (
    <Create
      {...props}
      mutationOptions={{ onSuccess }}
      transform={(data) => {
        const { parentIdField, isRootCategory, ...restData } = data;
        return {
          ...restData,
          parent: isRootCategory || !parentIdField ? null : parentIdField,
          featured: false,
        };
      }}
    >
      <SimpleForm>
        <div
          style={{
            display: "flex",
            gap: "30px",
            flexDirection: "row",
            width: "100%",
          }}
        >
          <TextInput
            source="name"
            label="Nombre"
            validate={[required(), maxLength(100)]}
          />
          <TextInput
            source="slug"
            label="Slug"
            validate={[
              required(),
              maxLength(100),
              regex(
                /^[a-z0-9-]+$/,
                "Solo se permiten letras minúsculas, números y guiones. Sin espacios."
              ),
            ]}
          />
        </div>
        <BooleanInput
          source="isRootCategory"
          label="Es categoría Padre"
          defaultValue={false}
        />
        <FormDataConsumer>
          {({ formData, ...rest }) => (
            <ConditionalParentCategoryInput formData={formData} {...rest} />
          )}
        </FormDataConsumer>
        <ImageInput
          source="image"
          label="Imagen"
          accept={{
            "image/*": [".png", ".jpg", ".jpeg", ".gif"],
          }}
          placeholder="Haz clic aquí o arrastra y suelta la imagen"
          options={{
            preventDropOnDocument: true,
          }}
        >
          <ImageField source="src" title="title" />
        </ImageInput>
      </SimpleForm>
    </Create>
  );
};
